var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"toggle",class:{toggle:true,active:_vm.active},on:{"click":function($event){return _vm.onClick()}}},[_c('span',{staticClass:"cross"},[_vm._v(" ✕ ")]),_c('span',{staticClass:"inner"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }